import i18n from "@/config/lang.js"

const CheckCurrency = currency => {
  if (currency == "NTD" || currency == "JPY" || currency == "TWD" || currency == "INR") {
    return true
  } else {
    return false
  }
}

const DownloadFile = (blob, fileName) => {
  const link = document.createElement("a")
  link.href = window.URL.createObjectURL(blob)
  link.setAttribute("download", fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link);
}


const CheckIfDuplicateExists = array => {
  return new Set(array).size !== array.length
}

const Translate = paramName => {
  let locale = i18n.locale
  let message = i18n.messages[locale]
  return message[paramName]
}

const CheckNotEmpty = source => {
  return source != null && source != undefined && source != ""
}

const CheckNotChinese = source => {
  let regExp = /^[\d|a-zA-Z|_]+$/
  return regExp.test(source)
}

const CheckEmail = source => {
  let regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regExp.test(source)
}

const Message = (instance, type = "success", message) => {
  instance.$Message[type]({
    background: false,
    content: message,
  })
}


const DateToString = (date, splitType) => {
  let mm = date.getMonth() + 1
  let dd = date.getDate()
  return [date.getFullYear(), (mm > 9 ? "" : "0") + mm, (dd > 9 ? "" : "0") + dd].join(splitType)
}

const DateTimeToString = (date, splitType) => {
  let MM = date.getMonth() + 1
  let dd = date.getDate()
  let hh = pad(date.getHours(), 2)
  let mm = pad(date.getMinutes(), 2)
  let ss = pad(date.getSeconds(), 2)
  let dateString = [date.getFullYear(), (MM > 9 ? "" : "0") + MM, (dd > 9 ? "" : "0") + dd].join(splitType)
  let timeString = [hh, mm, ss].join(":")
  return dateString + " " + timeString
}

const pad = (number, length) => {
  var str = '' + number;
  while (str.length < length) {
    str = '0' + str;
  }
  return str;
}

const DateToNumber = date => {
  let dd = String(date.getDate()).padStart(2, "0")
  let mm = String(date.getMonth() + 1).padStart(2, "0")
  let yyyy = date.getFullYear()
  return parseInt(yyyy + mm + dd)
}

const AddMonths = (date, months) => {
  date.setMonth(date.getMonth() + months);
  return date
}

const AddWeeks = (date, weeks) => {
  date.setDate(date.getDate() + weeks * 7);
  return date
}

const AddDays = (date, days) => {
  date.setDate(date.getDate() + days);
  return date
}

const MinusDays = (date, days) => {
  date.setDate(date.getDate() - days);
  return date
}

const DateValidationCheck = date => {
  if (!/^[0-9]{8}$/.test(date)) {
    return false
  }
  let year, month, day
  year = date.substring(0, 4)
  month = date.substring(4, 6)
  day = date.substring(6, 8)
  let iaMonthDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
  if (year < 1700 || year > 2500) {
    return false
  }
  if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
    iaMonthDays[1] = 29
  }
  if (month < 1 || month > 12) {
    return false
  }
  if (day < 1 || day > iaMonthDays[month - 1]) {
    return false
  }
  return true
}

const CheckNumber = testNumber => {
  let temp
  if (typeof testNumber == "number") {
    temp = testNumber.toString()
  } else {
    temp = testNumber
  }
  let re = /^\+?[1-9][0-9]*$/
  let regExp = /^[\d|a-zA-Z|_]+$/
  if (re.test(temp) && regExp.test(temp)) {
    return true
  } else {
    return false
  }
}

const CheckNumberWithNegative = testNumber => {
  let temp
  if (typeof testNumber == "number") {
    temp = testNumber.toString()
  } else {
    temp = testNumber
  }
  let re = /^(\-|\+)?[1-9][0-9]*$/
  let regExp = /^[\d|a-zA-Z|_]+$/
  if (re.test(temp) && regExp.test(temp)) {
    return true
  } else {
    return false
  }
}

const CheckFloat = testNumber => {
  let temp
  if (typeof testNumber == "number") {
    temp = testNumber.toString()
  } else {
    temp = testNumber
  }
  let re = /^\+?[0-9]*.[0-9]*$/
  let regExp = /^[\d|a-zA-Z|.|_]+$/
  if (re.test(temp) && regExp.test(temp)) {
    return true
  } else {
    return false
  }
}

const ExceptionHandling = errorMsg => {
  let text = ""
  if (errorMsg) {
    if (errorMsg.status == 401) {
      text = Translate("COMMON_MESSAGE_NOT_AUTH")
    } else if (errorMsg.data) {
      if (Array.isArray(errorMsg.data.messages)) {
        errorMsg.data.messages.forEach(message => {
          text = text.concat(message, "<br/>")
        })
      } else {
        text = errorMsg.data
      }
    } else {
      text = Translate("COMMON_MESSAGE_SYSTEM_ERROR")
    }
  }
  return text
}

const FloraEditorConfig = (height) => {
  return {
    key: process.env.VUE_APP_FLORA_KEY,
    inlineMode: false,
    height: height ? height : '400',
    toolbarButtons: {
      moreText: {
        buttons: [
          "bold",
          "italic",
          "underline",
          "strikeThrough",
          "fontFamily",
          "fontSize",
          "textColor",
          "backgroundColor",
          "clearFormatting",
        ],
      },
      moreParagraph: {
        buttons: [
          "alignLeft",
          "alignCenter",
          "formatOLSimple",
          "alignRight",
          "formatOL",
          "formatUL",
          "paragraphFormat",
          "outdent",
          "indent",
        ],
      },
      moreRich: {
        buttons: ["insertTable"],
      },
      moreMisc: {
        buttons: ["undo", "redo", "html"],
        align: "right",
        buttonsVisible: 2,
      },
    },
    tableEditButtons: [
      "tableHeader",
      "tableRemove",
      "|",
      "tableRows",
      "tableColumns",
      "-",
      "tableCells",
      "tableCellBackground",
      "tableCellVerticalAlign",
      "tableCellHorizontalAlign",
    ],
    quickInsertButtons: [
      'image',
      "table",
      "ol",
      "ul",
    ],
    imageEditButtons: [
      'imageAlign', 
      'imageRemove',
    ],
    // requestWithCORS: true,
    // imageUploadURL: process.env.VUE_APP_FILE_URL + '/upload8dformattachment?FormNo=' + FormNo + '&api-key=' + process.env.VUE_APP_APIKEY,
    imageUploadParams: { uploadType: "IMAGE" },
    requestWithCredentials: false,
    imageUploadMethod: "POST",
    imageMaxSize: 5 * 1024 * 1024,
    imageAllowedTypes: ["jpeg", "jpg", "png", "gif"],
    fileUpload: false,
    initOnClick: false,
    fileUploadParam: "file",
    // fileUploadURL: process.env.VUE_APP_FILE_URL + '/upload8dformattachment?FormNo=' + FormNo + '&api-key=' + process.env.VUE_APP_APIKEY,
    fileUploadParams: { uploadType: "FILE" },
    fileUploadMethod: "POST",
    fileMaxSize: 10 * 1024 * 1024,
    videoUpload: false,
    videoUploadParam: "file",
    // videoUploadURL: '../api/uploadattachment/',
    videoUploadParams: { uploadType: "VIDEO" },
    videoUploadMethod: "POST",
    videoMaxSize: Math.floor(100.04 * 1024 * 1024), // need to change .net api size limit
    // contenteditable: false,
    // charCounterCount: true,
    events: {
      initialized: (e, editor) => {
        // editor.events.on('drop', this.onImageDrop.bind(null, e, editor), true)
      },
      "froalaEditor.contentChanged": (e, editor) => {
        // this.$emit('on-change', editor.html.get(true))
      },
      "image.beforeUpload": function (files) {
        var editor = this;
        if (files.length) {
          // Create a File Reader.
          var reader = new FileReader();
          // Set the reader to insert images when they are loaded.
          reader.onload = function (e) {
            var result = e.target.result;
            editor.image.insert(result, null, null, editor.image.get());
          };
          // Read image as base64.
          reader.readAsDataURL(files[0]);
        }
        editor.popups.hideAll();
        // Stop default upload chain.
        return false;
      }
    },
  }
}

export {
  DownloadFile,
  CheckIfDuplicateExists,
  Translate,
  CheckNotChinese,
  CheckEmail,
  CheckNotEmpty,
  DateToString,
  DateTimeToString,
  CheckCurrency,
  CheckNumber,
  CheckNumberWithNegative,
  CheckFloat,
  DateValidationCheck,
  DateToNumber,
  FloraEditorConfig,
  Message,
  ExceptionHandling,
  AddMonths,
  AddWeeks,
  AddDays,
  MinusDays
}
